import { useTypedParams } from "react-router-typesafe-routes";

import { ApplicationUsersCard } from "@components/ClientApplication/ApplicationUsersCard";

import { routes } from "@pages/routes";

export const ApplicationUsers = () => {
  const { clientId, applicationId } = useTypedParams(
    routes.portal.clients.client.applications.application.users,
  );

  return (
    <ApplicationUsersCard
      clientId={clientId}
      applicationId={applicationId}
      title="Users"
    />
  );
};
